<template>
    <div>
        <!-- <div class="vx-row py-2 mx-0 cal-btn-list">
            <div class="p-2 px-4 flex justify-center" v-for="num in 9" :key="num">
                <btn-custom type="border" class="text-4xl p-5 py-3 m-0 rounded-full cal-button" :value="num" v-on:click="append(num)">{{num}}</btn-custom>
            </div>
            <div class="p-2 px-4 flex justify-center" :style="{'visibility: hidden' : type=='staff-code'}">
                <btn-custom type="border" class="text-4xl p-5 py-3 m-0 font-bold rounded-full cal-button" value="10" @click="dot">.</btn-custom>
            </div>
            <div class="p-2 px-4 flex justify-center">
                <btn-custom type="border" class="text-4xl p-5 py-3 m-0 rounded-full cal-button" value="0" @click="append('0')">0</btn-custom>
            </div>
            <div class="p-2 px-4 flex justify-center">
                <btn-custom type="border" class="p-5 py-3 m-0 rounded-full backspace-con cal-button" v-on:click="deleteNum()">
                    <i class="material-icons pt-1 pr-1 backspace-icon">backspace</i>
                </btn-custom>
            </div>
        </div> -->
        <div class="vx-row mx-0 cal-btn-list mt-3">
            <div class="flex justify-center con-btn" v-for="num in 9" :key="num">
                <btn-custom color="custom" type="border" class="text-4xl p-5 m-0 cal-button" :value="num" v-on:click="append(num)">{{num}}</btn-custom>
            </div>
            <div class="flex justify-center con-btn" :class="{'btn-hidden': type=='staff_code'}">
                <btn-custom color="custom" type="border" class="text-4xl p-5 m-0 font-bold cal-button" value="10" @click="dot">.</btn-custom>
            </div>
            <div class="flex justify-center con-btn">
                <btn-custom color="custom" type="border" class="text-4xl p-5 m-0 cal-button" value="0" @click="append('0')">0</btn-custom>
            </div>
            <div class="flex justify-center con-btn">
                <btn-custom color="custom" type="border" class="p-5 m-0 backspace-con cal-button" v-on:click="deleteNum()">
                    <i class="material-icons pt-1 pr-1 backspace-icon">backspace</i>
                </btn-custom>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'calculator-button',
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // number: '0'
        }
    },
    methods: {
        append(num) {
            this.$emit('append', num);
        },
        dot() {
            this.$emit('dot');
        },
        deleteNum(){
            this.$emit('deleteNum');
        }
    }
}
</script>
<style>
.btn-hidden {
    visibility: hidden !important;
}
</style>